
import React, { useState } from "react";
import { Button, Form, FormGroup } from "reactstrap";
import OutputPage from "./OutputPage";
import "./Dashboard.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import background from "../assets/img/Background.png"
import { IoInformationCircleOutline } from "react-icons/io5";
import './Tooltip.css';

export default function Dashboard() {
  const [messages, setMessages] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isMessageLoading, setIsMessageLoading] = useState(false);
  const [isAPICallStarted, setIsAPICallStarted] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isResetting, setIsResetting] = useState(false);

  const [updateValue, setUpdateValue] = useState({
    name: '',
    age: 0,
    current_credit_score: 0,
    total_debt: 0,
    number_of_loans: 0,
    payment_history: '',
    income: 0,
    debt_to_income_ratio: 0,
  });

  const handleInputChange = {
    name: (e) => {
      setUpdateValue((prevState) => ({ ...prevState, name: e.target.value }));
    },
    age: (e) => {
      setUpdateValue((prevState) => ({ ...prevState, age: e.target.value }));
    },
    current_credit_score: (e) => {
      setUpdateValue((prevState) => ({
        ...prevState,
        current_credit_score: e.target.value,
      }));
    },
    total_debt: (e) => {
      setUpdateValue((prevState) => ({
        ...prevState,
        total_debt: e.target.value,
      }));
    },
    number_of_loans: (e) => {
      setUpdateValue((prevState) => ({
        ...prevState,
        number_of_loans: e.target.value,
      }));
    },
    payment_history: (e) => {
      setUpdateValue((prevState) => ({
        ...prevState,
        payment_history: e.target.value,
      }));
    },
    income: (e) => {
      setUpdateValue((prevState) => ({ ...prevState, income: e.target.value }));
    },
    debt_to_income_ratio: (e) => {
      setUpdateValue((prevState) => ({
        ...prevState,
        debt_to_income_ratio: e.target.value,
      }));
    },
  };
  const handleSendMessage = async (type) => {
    if (type === "reset") {
      setIsResetting(true);
      setTimeout(() => {
        setUpdateValue({
          name: "",
          age: 0,
          current_credit_score: 0,
          income: 0,
          total_debt: 0,
          payment_history: "",
          number_of_loans: 0,
          debt_to_income_ratio: 0,
        });
        setIsResetting(false);
        toast.success("All fields got Reset!");
      }, 500);
    } else if (type === "generator") {
      setIsLoading(true);
      setIsAPICallStarted(true);

      const {
        name,
        age,
        current_credit_score,
        income,
        total_debt,
        payment_history,
        number_of_loans,
        debt_to_income_ratio,
      } = updateValue;

      for (const [key, value] of Object.entries(updateValue)) {
        if (
        ((key === "name" && !value) || (key === "age" && !value) || (key === "current_credit_score" && !value) || (key === "income" && !value) || (key === "total_debt" && !value) || (key === "number_of_loans" && !value) || (key === "debt_to_income_ratio" && !value))
	) {
          toast.error(`${key.replace(/_/g, " ")} is required`);
          setIsLoading(false);

          setIsAPICallStarted(false);
          return;
        }
        if (key !== "name" && key !== "payment_history") {
          if (isNaN(value) || Number(value) < 0) {
            toast.error(
              `${key.replace(/_/g, " ")} must be a non-negative number.`
            );
            setIsLoading(false);
            setIsAPICallStarted(false);
            return;
          }
        }
      }

      const commandString = `"${name}" ${age} ${current_credit_score} ${income} ${total_debt} "${payment_history}" ${number_of_loans}   ${debt_to_income_ratio}`;
      setTimeout(() => {
        setIsMessageLoading(true);
      }, 500);
      try {
        const response = await axios.post("https://ai-horizon.io/finance/credit-risk-assessment-tool/chat", updateValue);
        console.log("response", response.data);
        let newResponse = response.data.output
        let newResponseArr = newResponse.split(" ");
        for (let i = 0; i < newResponseArr.length; i++) {
          const nextWord = newResponseArr[i];
          delayPara(i, nextWord + " ")

        }
      } catch (error) {
        console.error("Error fetching AI response:", error);
        toast.error("Error generating response!");
        setIsAPICallStarted(false)
        setIsMessageLoading(false)
      } finally {
        setIsLoading(false);
        setMessages("")
      }
    }
  };

  const delayPara = (index, nextWord) => {
    setIsMessageLoading(false)
    setTimeout(() => {
      setMessages(prev => prev + nextWord)
    }, 75 * index)
  }

  return (
    <>
      <div
        style={{
          // backgroundColor: "#0D251E",
          backgroundImage: `url(${background})`,
          backgroundPosition: 'center',
        }}
      >
        <p
          style={{
            textAlign: "center",
            fontWeight: "600",
            fontSize: "20px",
            fontFamily: "sans-serif",
            color: "#fff",
            paddingTop: "20px",
            marginBottom: "20px",
          }}
        >
          Credit Risk Assessment Agent
        </p>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <p
            style={{
              color: "#fff",
              fontSize: "clamp(16px, 4vw + 1rem, 1px)",
              fontFamily: "sans-serif",
              width: "90%",
              whiteSpace: "balance",
              marginLeft: "10%",
            }}
            className="aboutSection"
          >
            <h3
              style={{
                color: "#fff",
                fontSize: "clamp(16px, 4vw + 1rem, 18px)",
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              About
            </h3>
            The Credit risk assessment agent offers personalized financial guidance to help users enhance their credit scores. By analyzing crucial factors such as credit card utilization and payment history, the advisor identifies specific areas for improvement. It provides tailored strategies designed to empower users to make informed financial decisions, ultimately leading to better creditworthiness and financial health.
            <p
              style={{
                marginTop: "10px",
                whiteSpace: "balance",
                // maxWidth: "68vw",
              }}
              className="disclaimerWidth"
            >
              <span style={{ fontSize: "18px", fontWeight: "600" }}>
                Disclaimer
              </span>
              <span style={{ color: "red", fontSize: "20px" }}>*</span>: The advice and insights provided by our agent is based on general financial data and trends. We recommend consulting a certified financial advisor to assess the suitability of these recommendations for your individual financial circumstances.
            </p>
          </p>
        </div>
        <div
          className="dashboard-main"
          style={{
            justifyContent: "center",
            marginRight: "20px",
          }}
        >
          <div
            style={{
              backgroundColor: "#014E52",
              padding: "15px",
              borderRadius: "10px",
              width: "auto",
            }}
           
          >
            <Form >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "1rem",
                }}
              >
                <FormGroup>
                  <div>
                    <label
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "14px",
                        color: "#fff",
                        fontWeight: "600",
                      }}
                       className="fontResponsive"
                    >
                      Name<span style={{ color: "red", fontSize: "20px" }}>*</span>
                    </label>
                    <input
                      placeholder="Enter Name"
                      type="text"
                      style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: "transparent",
                        border: "1px solid #fff",
                        borderRadius: "10px",
                        padding: 3,
                        color: "#fff",
                        marginTop: "12px",
                        marginBottom: "16px",
                      }}
                      value={updateValue.name}
                      onChange={handleInputChange.name}
                    />
                  </div>
                </FormGroup>

                <FormGroup>
                  <div>
                    <label
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "14px",
                        color: "#fff",
                        fontWeight: "600",
                      }}
                       className="fontResponsive"
                    >
                      Age<span style={{ color: "red", fontSize: "20px" }}>*</span>
                    </label>
                    <input
                      placeholder="Enter Age"
                      type="text"
                      style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: "transparent",
                        border: "1px solid #fff",
                        borderRadius: "10px",
                        padding: 3,
                        color: "#fff",
                        marginTop: "12px",
                        marginBottom: "16px",
                      }}
                      value={updateValue.age}
                      onChange={handleInputChange.age}
                    />
                  </div>
                </FormGroup>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "1rem",
                }}
              >
                <FormGroup>
                  <div>
                    <label
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "13px",
                        color: "#fff",
                        fontWeight: "600",
                      }}
                      className="tooltip-wrapper fontResponsive" onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      Current credit score
                      <span style={{ color: "red", fontSize: "20px" }}
                      >
                        <IoInformationCircleOutline size={14} style={{ color: 'white' }} />
                      </span>
                      {showTooltip && (
                        <div className="tooltip-box" >
                          Current credit score. Example: 750.
                          <span className="tooltip-arrow"></span>
                        </div>

                      )}
                    </label>
                    <input
                      placeholder="Enter a Current credit score"
                      type="text"
                      style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: "transparent",
                        border: "1px solid #fff",
                        borderRadius: "10px",
                        padding: 3,
                        color: "#fff",
                        marginTop: "12px",
                        marginBottom: "16px",
                      }}
                      value={updateValue.current_credit_score}
                      onChange={handleInputChange.current_credit_score}
                    />
                  </div>
                </FormGroup>

                <FormGroup>
                  <div>
                    <label
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "14px",
                        color: "#fff",
                        fontWeight: "600",
                      }}
                      className="tooltip-wrapper fontResponsive" onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      Total Debt  <span style={{ color: "red", fontSize: "20px" }}
                      >
                        <IoInformationCircleOutline size={15} style={{ color: 'white' }} />
                      </span>
                      {showTooltip && (
                        <div className="tooltip-box" >
                          Total debt amount. Example: Rs 5,00,000.
                          <span className="tooltip-arrow"></span>
                        </div>
                      )}
                    </label>
                    <input
                      placeholder="Enter total debt"
                      type="text"
                      style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: "transparent",
                        border: "1px solid #fff",
                        borderRadius: "10px",
                        padding: 3,
                        color: "#fff",
                        marginTop: "12px",
                        marginBottom: "16px",
                      }}
                      value={updateValue.total_debt}
                      onChange={handleInputChange.total_debt}
                    />
                  </div>
                </FormGroup>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "1rem",
                }}
                
              >
                <FormGroup>
                  <div>
                    <label
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "14px",
                        color: "#fff",
                        fontWeight: "600",
                      }}
                      className="tooltip-wrapper fontResponsive" onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                    >
                      Number of loans
                      <span style={{ color: "red", fontSize: "20px" }}
                      >
                        <IoInformationCircleOutline size={15} style={{ color: 'white' }} />
                      </span>
                      {showTooltip && (
                        <div className="tooltip-box" >
                          Active loan count. Example: 2 loans
                          <span className="tooltip-arrow"></span>
                        </div>
                      )}
                    </label>
                    <input
                      placeholder="Enter Number of loans"
                      type="text"
                      style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: "transparent",
                        border: "1px solid #fff",
                        borderRadius: "10px",
                        padding: 3,
                        color: "#fff",
                        marginTop: "12px",
                        marginBottom: "16px",
                      }}
                      value={updateValue.number_of_loans}
                      onChange={handleInputChange.number_of_loans}
                    />
                  </div>
                </FormGroup>
                <FormGroup>
                  <div>
                    <label
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "14px",
                        color: "#fff",
                        fontWeight: "600",
                      }}
                      className="tooltip-wrapper fontResponsive" onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      Payment history  <span style={{ color: "red", fontSize: "20px" }}
                      >
                        <IoInformationCircleOutline size={15} style={{ color: 'white' }} />
                      </span>
                      {showTooltip && (
                        <div className="tooltip-box" >
                          On-time/missed payments. Example: All on-time.
                          <span className="tooltip-arrow"></span>
                        </div>
                      )}
                    </label>
                    <input
                      placeholder="Enter Payment history"
                      type="text"
                      style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: "transparent",
                        border: "1px solid #fff",
                        borderRadius: "10px",
                        padding: 3,
                        color: "#fff",
                        marginTop: "12px",
                        marginBottom: "16px",
                      }}
                      value={updateValue.payment_history}
                      onChange={handleInputChange.payment_history}
                    />
                  </div>
                </FormGroup>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "1rem",
                }}
              >
                <FormGroup>
                  <div>
                    <label
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "14px",
                        color: "#fff",
                        fontWeight: "600",
                      }}
                      className="tooltip-wrapper fontResponsive" onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      Income
                      <span style={{ color: "red", fontSize: "20px" }}
                      >
                        <IoInformationCircleOutline size={15} style={{ color: 'white' }} />
                      </span>
                      {showTooltip && (
                        <div className="tooltip-box" >
                          Yearly income. Example: Rs 6,00,000.
                          <span className="tooltip-arrow"></span>
                        </div>
                      )}
                    </label>
                    <input
                      placeholder="Enter Income"
                      type="text"
                      style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: "transparent",
                        border: "1px solid #fff",
                        borderRadius: "10px",
                        padding: 3,
                        color: "#fff",
                        marginTop: "12px",
                        marginBottom: "16px",
                      }}
                      value={updateValue.income}
                      onChange={handleInputChange.income}
                    />
                  </div>
                </FormGroup>
                <FormGroup>
                  <div>
                    <label
                      style={{
                        fontFamily: "sans-serif",
                        fontSize: "13px",
                        color: "#fff",
                        fontWeight: "600",
                      }}
                      className="tooltip-wrapper fontResponsive" onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      Debt to income ratio  <span style={{ color: "red", fontSize: "20px" }}
                      >
                        <IoInformationCircleOutline size={14} style={{ color: 'white' }} />
                      </span>
                      {showTooltip && (
                        <div className="tooltip-box" >
                          Debt-to-income percentage. Example: 25%.
                          <span className="tooltip-arrow"></span>
                        </div>
                      )}
                    </label>
                    <input
                      placeholder="Enter Debt to income ratio"
                      type="text"
                      style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: "transparent",
                        border: "1px solid #fff",
                        borderRadius: "10px",
                        padding: 3,
                        color: "#fff",
                        marginTop: "12px",
                        marginBottom: "16px",
                      }}
                      value={updateValue.debt_to_income_ratio}
                      onChange={handleInputChange.debt_to_income_ratio}
                    />
                  </div>
                </FormGroup>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "1rem",
                }}
              >
                <Button
                  style={{
                    width: "40%",
                    backgroundColor: isLoading ? "#FFD68A" : "#F3A01E",
                    color: "#fff",
                    fontWeight: "600",
                    height: "35px",
                    borderRadius: "10px",
                    marginTop: "12px",
                    marginBottom: "16px",
                    border: "none",
                    cursor: "pointer",
                  }}
                  disabled={isLoading}
                  onClick={() => handleSendMessage("generator")}
                >
                  {isLoading ? "Loading..." : "Generate"}
                </Button>
                <Button
                  style={{
                    width: "40%",
                    backgroundColor: isResetting ? "#B1D4E0" : "#145DA0",
                    color: "#fff",
                    fontWeight: "600",
                    height: "35px",
                    borderRadius: "10px",
                    marginTop: "12px",
                    marginBottom: "16px",
                    border: "none",
                    cursor: "pointer",
                  }}
                  disabled={isResetting}
                  onClick={() => handleSendMessage("reset")}
                >
                  {isResetting ? "Resetting..." : "Reset"}
                </Button>
              </div>
            </Form>
          </div>

          {isAPICallStarted && (
            <>
              <OutputPage messages={messages} isMessageLoading={isMessageLoading} />
              {/* <div ref={messageEndRef} /> */}
            </>
          )}
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

